module.exports = __webpack_public_path__ + "img/card-background.2578d7ce.png";